module.exports = __webpack_public_path__ + "fonts/gaxon.32cebc42.eot";